import { SvgType } from 'components/svgComponent/Svg'
import Dashboard from 'components/svgComponent/Dashboard'
import Jobs from 'components/svgComponent/Jobs'
import JobDrafts from 'components/svgComponent/JobDrafts'
import Clients from 'components/svgComponent/Clients'
import Recruiters from 'components/svgComponent/Recruiters'
import Calendar from 'components/svgComponent/Calendar'
import Messages from 'components/svgComponent/Messages'
import SearchCandidates from 'components/svgComponent/SearchCandidates'
import Notification from 'components/svgComponent/notification/MenuIcon'
import RepeatSkills from '../components/svgComponent/RepeatSkills'

interface ServerRoles {
  [index: string]: string
  manager: string
  recruiter: string
  recruiterExternal: string
  recruiterWithOutManagers: string
  candidate: string
  super_manager: string
}
export const ServerRoles: ServerRoles = {
  manager: 'manager',
  recruiter: 'recruiter',
  recruiterExternal: 'recruiterExternal',
  recruiterWithOutManagers: 'recruiterWithOutManagers',
  candidate: 'candidate',
  super_manager: 'super_manager'
}

export const Roles: { [index: string]: string } = {
  manager: 'Hiring Manager',
  recruiter: 'Recruiter',
  candidate: 'Candidate',
  super_manager: 'Super Hire manager'
}

export interface ItemRoleType {
  icon: (props: SvgType) => JSX.Element
  name: string
  to: string
  count?: number
}

interface ObjectType {
  [index: string]: ItemRoleType[]
}

export const RolesMenu: ObjectType = {
  super_manager: [
    {
      icon: Dashboard,
      name: 'Dashboard',
      to: '/dashboard'
    },
    {
      icon: Jobs,
      name: 'Jobs',
      to: '/jobs'
    },
    {
      icon: JobDrafts,
      name: 'Job Drafts',
      to: '/manager/job-drafts'
    },
    {
      icon: Clients,
      name: 'Clients',
      to: '/clients'
    },
    {
      icon: Notification,
      name: 'Notifications',
      to: '/notifications'
    }
  ],
  manager: [
    {
      icon: Dashboard,
      name: 'Dashboard',
      to: '/dashboard'
    },
    {
      icon: Jobs,
      name: 'Jobs',
      to: '/jobs'
    },
    {
      icon: JobDrafts,
      name: 'Job Drafts',
      to: '/manager/job-drafts'
    },
    {
      icon: Clients,
      name: 'Clients',
      to: '/clients'
    },
    {
      icon: Recruiters,
      name: 'Recruiters',
      to: '/manager/recruiters'
    },
    {
      icon: Messages,
      name: 'Campaigns',
      to: '/campaigns'
    },
    {
      icon: RepeatSkills,
      name: 'Associated Skills',
      to: '/skills'
    },
    {
      icon: Calendar,
      name: 'Calendar',
      to: '/calendar'
    },
    {
      icon: Notification,
      name: 'Notifications',
      to: '/notifications'
    }
    // {
    //   icon: Zoom,
    //   name: 'Zoom',
    //   to: '/zoom'
    // }
  ],
  recruiterWithOutManagers: [
    {
      icon: Dashboard,
      name: 'Dashboard',
      to: '/dashboard'
    },
    {
      icon: SearchCandidates,
      name: 'Search candidates',
      to: '/recruiter/candidates'
    },
    // Messages disabled per design requirements
    // {
    //   icon: Messages,
    //   name: 'Messages',
    //   to: '/messages'
    // },
    {
      icon: Notification,
      name: 'Notifications',
      to: '/notifications'
    }
  ],
  recruiterExternal: [
    {
      icon: Dashboard,
      name: 'Dashboard',
      to: '/dashboard'
    },
    {
      icon: SearchCandidates,
      name: 'Search candidates',
      to: '/recruiter/candidates'
    },
    {
      icon: Jobs,
      name: 'Jobs',
      to: '/jobs'
    },
    // Messages disabled per design requirements
    // {
    //   icon: Messages,
    //   name: 'Messages',
    //   to: '/messages'
    // },
    {
      icon: Notification,
      name: 'Notifications',
      to: '/notifications'
    }
  ],
  recruiter: [
    {
      icon: Dashboard,
      name: 'Dashboard',
      to: '/dashboard'
    },
    {
      icon: Jobs,
      name: 'Jobs',
      to: '/jobs'
    },
    {
      icon: SearchCandidates,
      name: 'Search candidates',
      to: '/recruiter/candidates'
    },
    {
      icon: Recruiters,
      name: 'Resumes',
      to: '/resumes'
    },
    // Messages disabled per design requirements
    // {
    //   icon: Messages,
    //   name: 'Messages',
    //   to: '/messages'
    // },
    {
      icon: Notification,
      name: 'Notifications',
      to: '/notifications'
    }
    // {
    //   icon: Zoom,
    //   name: 'Zoom',
    //   to: '/zoom'
    // }
  ],
  candidate: [
    {
      icon: Dashboard,
      name: 'Dashboard',
      to: '/dashboard'
    },
    {
      icon: Jobs,
      name: 'Jobs',
      to: '/jobs'
    },
    {
      icon: Calendar,
      name: 'Calendar',
      to: '/calendar'
    }
    // Messages and Notifications disabled per design requirements
    // {
    //   icon: Messages,
    //   name: 'Messages',
    //   to: '/messages'
    // },
    // {
    //   icon: Notification,
    //   name: 'Notifications',
    //   to: '/notifications'
    // }
    // {
    //   icon: Zoom,
    //   name: 'Zoom',
    //   to: '/zoom'
    // }
  ],
  guest: [
    {
      icon: Jobs,
      name: 'Jobs',
      to: '/jobs'
    },
    {
      icon: Calendar,
      name: 'Calendar',
      to: '/log-in'
    },
    {
      icon: Messages,
      name: 'Messages',
      to: '/log-in'
    },
    {
      icon: Notification,
      name: 'Notifications',
      to: '/log-in'
    }
  ]
}
